(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fit-picker"] && !Shopify.designMode) return;
  try {
    class FitPicker extends HTMLElement {
      connectedCallback() {
        if (this._initialised) return;
        this._initialised = true;
        this.init();
      }

      async init() {
        const data = this.dataset;
        const token = data.token;
        const siblingGroup = data.siblingStyleGroup;
        const domain = data.shopDomain;
        const version = data.apiVersion || '2026-07';

        if (!token || !siblingGroup || !domain) return;

        const query =
          'query($q: String!) {' +
          '  products(first: 30, query: $q) {' +
          '    nodes { title handle availableForSale tags }' +
          '  }' +
          '}';
        const variables = { q: "tag:'style_group:" + siblingGroup + "'" };

        // Cache the sibling group's products per session: most PDPs have no
        // sibling fit (cached as an empty list, so no re-query), and browsing
        // colours within one fit reuses the same group result.
        const cacheKey = 'fitpicker:' + version + ':' + siblingGroup;
        let nodes = null;
        try {
          const cached = sessionStorage.getItem(cacheKey);
          if (cached !== null) nodes = JSON.parse(cached);
        } catch (error) {
          nodes = null;
        }

        if (nodes === null) {
          try {
            const response = await fetch('https://' + domain + '/api/' + version + '/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': token
              },
              body: JSON.stringify({ query: query, variables: variables })
            });
            if (!response.ok) return;
            const json = await response.json();
            nodes = (json && json.data && json.data.products && json.data.products.nodes) || [];
            try { sessionStorage.setItem(cacheKey, JSON.stringify(nodes)); } catch (error) {}
          } catch (error) {
            return;
          }
        }

        if (!nodes.length) return;

        const colour = (data.currentColour || '').toLowerCase();
        let target = null;
        if (colour) {
          target = nodes.find(function (node) {
            return (node.tags || []).some(function (tag) {
              return tag.toLowerCase() === 'x-colourcode:' + colour;
            });
          });
        }
        if (!target) {
          target = nodes.find(function (node) { return node.availableForSale; }) || nodes[0];
        }

        const siblingUrl = '/products/' + target.handle;
        const currentIsWide = data.currentIsWide === 'true';
        const labelRegular = data.labelRegular || 'Regular';
        const labelWide = data.labelWide || 'Wide';
        const currentLabel = currentIsWide ? labelWide : labelRegular;
        const siblingLabel = currentIsWide ? labelRegular : labelWide;

        const currentButton = document.createElement('span');
        currentButton.className = 'fit-picker__option fit-picker__option--current';
        currentButton.setAttribute('aria-current', 'true');
        currentButton.textContent = currentLabel;

        const siblingButton = document.createElement('a');
        siblingButton.className = 'fit-picker__option';
        siblingButton.href = siblingUrl;
        siblingButton.textContent = siblingLabel;

        const options = this.querySelector('[data-fit-options]');
        if (!options) return;
        options.innerHTML = '';
        if (currentIsWide) {
          options.appendChild(siblingButton);
          options.appendChild(currentButton);
        } else {
          options.appendChild(currentButton);
          options.appendChild(siblingButton);
        }

        const currentLabelEl = this.querySelector('[data-fit-current-label]');
        if (currentLabelEl) currentLabelEl.textContent = currentLabel;

        this.hidden = false;
      }
    }

    if (!customElements.get('fit-picker')) {
      customElements.define('fit-picker', FitPicker);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-recipient-form"] && !Shopify.designMode) return;
  try {
    class RecipientForm extends HTMLElement {
    constructor() {
      super();
      this.emailInput = this.querySelector('[data-recipient-email]');
      this.confirmInput = this.querySelector('[data-recipient-email-confirm]');
      this.emailErrorEl = this.querySelector('[data-recipient-email-error]');
      this.confirmErrorEl = this.querySelector('[data-recipient-email-confirm-error]');
      this.form = this.closest('form');
    }

    connectedCallback() {
      if (!this.emailInput || !this.confirmInput || !this.form) return;

      this.onConfirmInput = this.onConfirmInput.bind(this);
      this.onEmailInput = this.onEmailInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      this.confirmInput.addEventListener('input', this.onConfirmInput);
      this.emailInput.addEventListener('input', this.onEmailInput);
      this.form.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      if (!this.form) return;
      this.confirmInput.removeEventListener('input', this.onConfirmInput);
      this.emailInput.removeEventListener('input', this.onEmailInput);
      this.form.removeEventListener('submit', this.onSubmit, true);
    }

    emailsMatch() {
      const a = (this.emailInput.value || '').trim().toLowerCase();
      const b = (this.confirmInput.value || '').trim().toLowerCase();
      return a === b;
    }

    setFieldError(input, errorEl, message) {
      if (message) {
        input.setAttribute('aria-invalid', 'true');
        input.setCustomValidity(message);
        if (errorEl) {
          errorEl.textContent = message;
          errorEl.removeAttribute('hidden');
        }
      } else {
        input.removeAttribute('aria-invalid');
        input.setCustomValidity('');
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.setAttribute('hidden', '');
        }
      }
    }

    setMismatchState(isMismatch) {
      const message = isMismatch
        ? (this.confirmErrorEl && this.confirmErrorEl.dataset.msgMismatch) || 'Emails do not match'
        : '';
      this.setFieldError(this.confirmInput, this.confirmErrorEl, message);
    }

    onConfirmInput() {
      if (!this.confirmInput.value) {
        this.setMismatchState(false);
        return;
      }
      this.setMismatchState(!this.emailsMatch());
    }

    onEmailInput() {
      if (this.emailInput.value.trim()) {
        this.setFieldError(this.emailInput, this.emailErrorEl, '');
      }
      if (!this.confirmInput.value) return;
      this.setMismatchState(!this.emailsMatch());
    }

    onSubmit(event) {
      const emailEmpty = !this.emailInput.value.trim();
      const confirmEmpty = !this.confirmInput.value.trim();
      let firstInvalid = null;

      if (emailEmpty) {
        const msg = (this.emailErrorEl && this.emailErrorEl.dataset.msgRequired) || 'This field is required';
        this.setFieldError(this.emailInput, this.emailErrorEl, msg);
        firstInvalid = this.emailInput;
      } else {
        this.setFieldError(this.emailInput, this.emailErrorEl, '');
      }

      if (confirmEmpty) {
        const msg = (this.confirmErrorEl && this.confirmErrorEl.dataset.msgRequired) || 'This field is required';
        this.setFieldError(this.confirmInput, this.confirmErrorEl, msg);
        firstInvalid = firstInvalid || this.confirmInput;
      } else if (!emailEmpty && !this.emailsMatch()) {
        this.setMismatchState(true);
        firstInvalid = firstInvalid || this.confirmInput;
      } else if (!emailEmpty) {
        this.setMismatchState(false);
      }

      if (firstInvalid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        firstInvalid.focus();
      }
    }
  }

  if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', RecipientForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["main-product-blocks"] && !Shopify.designMode) return;
  try {
    /* Update Collapsible tab SKU when variant changes */
  (function () {
    if (window.__pdpSkuListenerAttached) return;
    window.__pdpSkuListenerAttached = true;

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail || {};
      var sku = variant.sku || '';
      var nodes = document.querySelectorAll('[data-pdp-sku]');
      nodes.forEach(function (node) {
        var valueEl = node.querySelector('[data-pdp-sku-value]');
        if (valueEl) valueEl.textContent = sku;
        if (sku) {
          node.removeAttribute('hidden');
        } else {
          node.setAttribute('hidden', '');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
